/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Summaryreturninghint2Inputs */

const en_summaryreturninghint2 = /** @type {(inputs: Summaryreturninghint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guests who had checked in at an earlier event of yours.`)
};

const de_summaryreturninghint2 = /** @type {(inputs: Summaryreturninghint2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gäste, die schon bei einem früheren Event von dir eingecheckt hatten.`)
};

/**
* | output |
* | --- |
* | "Guests who had checked in at an earlier event of yours." |
*
* @param {Summaryreturninghint2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const summaryreturninghint2 = /** @type {((inputs?: Summaryreturninghint2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Summaryreturninghint2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_summaryreturninghint2(inputs)
	return de_summaryreturninghint2(inputs)
});
export { summaryreturninghint2 as "summaryReturningHint" }